import { render, staticRenderFns } from "./RankCount.vue?vue&type=template&id=552da9da&scoped=true"
import script from "./RankCount.vue?vue&type=script&lang=js"
export * from "./RankCount.vue?vue&type=script&lang=js"
import style0 from "./RankCount.vue?vue&type=style&index=0&id=552da9da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552da9da",
  null
  
)

export default component.exports